import { Drawer } from '@material-ui/core';
import * as lib from '~/dependencies';
import { colors } from '~/layout';

export const BoxSelector = lib.styled.div`
  display: flex;
  min-width: 211px;
  height: 26px;
  background-color: ${colors.lightGray10};
  border-radius: 15px;
  align-items: center;
  justify-content: ${props =>
    props.loading === 1 ? 'center' : 'space-between'};

  span {
    text-transform: none!important;
  }

  .MuiCircularProgress-colorPrimary {
    color: ${colors.black};
    opacity: 0.6;
  }
`;
export const Title = lib.styled.div`
  display: flex;
  width: 66px;
  height: 26px;
  background-color: ${colors.lightGray11};
  border-radius: 15px;
  text-align: center;
  justify-content: center;
  align-items: center;

  span:lang(es) {
    font-size: 9px;
  } 
  
  span:lang(fr) {
    font-size: 9px;
  } 
  
  span:lang(pt) {
    font-size: 9px;
  } 
  
  span:lang(de) {
    word-break: break-all;
    font-size: 8px;
  } 

  span {
    font-size: 10px;
    color: ${colors.black};
    opacity: 0.6;
  }
`;

export const Values = lib.styled.div`
  display: flex;
  min-width: 105px;
  height: 26px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  line-height: 10px;

  .MuiCircularProgress-colorPrimary {
    color: ${colors.black};
    opacity: 0.6;
  }

  span {
    text-transform: none!important;
    font-size: 12px;
    font-family: Nunito;
    color: #000;
    opacity: 0.7;
  }

  .padding {
    padding: 0 0 0 2px;
  }
`;

export const Row = lib.styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  flex-wrap: nowrap;

  .outbound-phone-name {
    font-size: 10px;
    color: ${colors.black};
    opacity: 0.6;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 18ch;
  }

  .outbound-phone-number {
    font-weight: 500;
    font-size: 10px;
    color: ${colors.black};
  }
`;

export const DrawerComponent = lib.styled(Drawer)`
  .MuiDrawer-paper {
    padding-bottom: 20px;
  }

  #boxTitle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 17px 15px 14px 15px;

    .title {
      font-size: 16px;
      color: ${colors.black};
    }

    .close {
      color: ${colors.lightGray06};
      cursor: pointer;
    }
  }

  .rowSelect {
    min-height: 48px;
    max-height: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid ${colors.lightGray06};
    background-color: ${colors.white02};
    border-radius: 10px;
    margin: 5px 12px 5px 12px;
    padding: 0px 15px 0px 15px;
    cursor: pointer;
    outline: none;
    flex-wrap: nowrap;

    &:hover {
      background-color: ${colors.lightGray05};
    }

    .left {
      display: flex;
      align-items: center;
      justify-content: flex-start;

      .flag {
        width: 15px;
        height: 11px;
        margin-right: 5px;
        margin-bottom: 3px;
      }

      span {
        font-size: 13px;
      }
    }

    .right {
      display: flex;
      align-items: center;
      justify-content: center;

      .check-icon {
        color: ${colors.green02};
        margin-left: 10px;
      }
    }
  }
`;
